export default {
	setPortfolio: ({ commit }, data) => {
		commit('setPortfolio', data)
	},
	getallPortfolio: async ({ commit, rootGetters, state }, without_allocation = true) => {
		const { external_client_id } = rootGetters.activeAccount

		if (_.isEmpty(state.portfolio)) {
			await axios
				.get(`/api/customers/${external_client_id}/portfolio`, {
					params: {
						without_allocation,
					},
				})
				.then(({ data: { data } }) => {
					commit('setPortfolio', data.portfolio)
				})
		}
	},
	updatePortfolio: ({ commit }, portfolio) => {
		commit('updatePortfolio', portfolio)
	},
}
